import React from 'react'

const OrderHistoryPage = () => {
    return (
        <div>

        </div>
    )
}

export default OrderHistoryPage